import { render } from "./clipboard.vue?vue&type=template&id=52839d54"
import script from "./clipboard.vue?vue&type=script&lang=js"
export * from "./clipboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__